






























































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

interface IWord {
  label: string,
  variations?: string | null,
  type?: string | null,
  sex?: string | null,
  root?: string | null,
  translation: string
}

@Component
export default class WordListB extends Vue {

  private wordList: IWord[] = [
      {
        label: "(á, í) brott",
        variations: "(á, í) braut",
        type: "Ad.",
        translation: "fort, weg"
      },
      {
        label: "(all)vel",
        variations: "betr, bezt",
        type: "Ad.",
        translation: "ganz gut"
      },
      {
        label: "á",
        variations: "ár, á, á, ár, áa, ám, ár",
        type: "S",
        sex: "f",
        translation: "Fluss"
      },
      {
        label: "á",
        type: "KW",
        translation: "m. Dat.: an, auf, bei, m. Akk: auf, an, in"
      },
      {
        label: "áðr",
        type: "Ad.",
        translation: "vorher, bevor"
      },
      {
        label: "ætla",
        variations: "ætlaða, ætlaðr",
        type: "V",
        root: "sw. II",
        translation: "glauben, meinen, beabsichtigen"
      },
      {
        label: "ætt",
        variations: "ættar, ætt, ætt, ættir, ætta, ættum, ætti",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Familie, Geschlecht"
      },
      {
        label: "af",
        type: "KW",
        translation: "m. Dat: von, von…her, Adv ab, weg, fort"
      },
      {
        label: "af því",
        variations: "fyrir því ",
        type: "KW",
        translation: "deshalb, deswegen (weil)"
      },
      {
        label: "afl",
        variations: "afls, afli, afl",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Kraft"
      },
      {
        label: "aldr",
        variations: "Gen. Aldrs",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Lebensalter, Zeitalter"
      },
      {
        label: "aldri",
        variations: "aldrigi",
        type: "Ad.",
        translation: "niemals"
      },
      {
        label: "allr",
        type: "A ",
        translation: "ganz, vollständig, vollkommen"
      },
      {
        label: "allt",
        type: "Ad.",
        translation: "ganz gut"
      },
      {
        label: "alþingi",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "das isländische Allthing"
      },
      {
        label: "andask",
        variations: "anaðask, andaðr",
        type: "V",
        root: "sw. II",
        translation: "sterben"
      },
      {
        label: "aptr",
        type: "Ad.",
        translation: "zurück, rückwärts"
      },
      {
        label: "at",
        variations: "an, in, um",
        type: "KW",
        translation: "m. Dat: bei, an, in, um, Adv.: an, heran, Inf. Zeichen"
      },
      {
        label: "atubrðr",
        variations: "atburðar, hatburð, hatburð, atburðir, atburða, atburðum, atburði",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Vorfall, Ereigniss"
      },
      {
        label: "auga",
        variations: "auga, auga, auga, augu, augna, augum, augu",
        type: "S",
        sex: "n",
        root: "n-Stamm",
        translation: "Auge"
      },
      {
        label: "austan",
        type: "Ad.",
        translation: "von Osten, nach Westen"
      },
      {
        label: "austmaðr",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Ostmann = Norweger"
      },
      {
        label: "austr",
        type: "Ad.",
        translation: "im Osten, nach Osten"
      },
      {
        label: "bak",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Ruecken"
      },
      {
        label: "bani",
        variations: "bana, bana, bana, banar, bana, bǫnum, bana",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Tod, Töter,"
      },
      {
        label: "bardagi",
        variations: "bardaga, bardaga, bardaga, bardagar, bardaga, bardǫgum, bardaga",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Schlacht, Kampf"
      },
      {
        label: "barn",
        variations: "barns, barni, barn, bǫrn, barna, bǫrnum, bǫrn",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Kind"
      },
      {
        label: "bátr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Boot"
      },
      {
        label: "beiða",
        variations: "beidda, beiddr",
        type: "V",
        root: "sw. I",
        translation: "fordern, verlangen"
      },
      {
        label: "bera",
        variations: "bar, bárum, borinn",
        type: "V",
        root: "IV. Abl.",
        translation: "tragen"
      },
      {
        label: "berja",
        variations: "berða, bar(i)ðr",
        type: "V",
        root: "sw. I",
        translation: "schlagen"
      },
      {
        label: "bíða",
        variations: "beið, biðum, beðinn",
        type: "V",
        root: "I. Abl.",
        translation: "(er)warten"
      },
      {
        label: "biðja",
        variations: "bað, báðum, beðinn",
        type: "V",
        root: "V. Abl.",
        translation: "bitten"
      },
      {
        label: "binda",
        variations: "batt, bundum, bundinn",
        type: "V",
        root: "III. Abl.",
        translation: "binden "
      },
      {
        label: "biskup",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Bischof"
      },
      {
        label: "bíta",
        variations: "beit, bitum, bitinn",
        type: "V",
        root: "I. Abl.",
        translation: "beissen"
      },
      {
        label: "bjóda",
        variations: "bauð, buðum, bodinn",
        type: "V",
        root: "II. Abl.",
        translation: "bieten, anbieten, einladen"
      },
      {
        label: "boð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Angebot, Einladung, Fest,"
      },
      {
        label: "bœr",
        variations: "bœjar, bœ, bœ, bœir, bœja, bœjum, bœir",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Hof, Gehöft, Stadt"
      },
      {
        label: "bœta",
        variations: "bœtta, bœttr",
        type: "V",
        root: "sw. I",
        translation: "büssen"
      },
      {
        label: "bóndi",
        variations: "bónda, bónda, bónda, bœndr, bónda, bóndum, bœndr",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Bauer"
      },
      {
        label: "borð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Brett, Bord, Tisch"
      },
      {
        label: "bót",
        variations: "bótar, bót, bót, bœtr, bóta, bótum, bœtr",
        type: "S",
        sex: "f",
        translation: "Besserung, Abhilfe, Heilung, Busse"
      },
      {
        label: "braðliga",
        type: "Ad.",
        translation: "bald, rasch, schnell"
      },
      {
        label: "braut",
        variations: "brautar, brautu, braut, brautir, brauta, brautum, brautir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Weg, fort"
      },
      {
        label: "bregða",
        variations: "brá, brugðum, brugðinn",
        type: "V",
        root: "III. Abl.",
        translation: "schnell bewegen, reagieren"
      },
      {
        label: "brjóta",
        variations: "braut, brutum, brotinn",
        type: "V",
        root: "II. Abl.",
        translation: "brechen"
      },
      {
        label: "bróðir",
        translation: "Bruder"
      },
      {
        label: "bú",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Haushalt, Wirtschaft"
      },
      {
        label: "búa",
        variations: "bió, bioggum/biuggum, búinn",
        type: "V",
        root: "red.",
        translation: "(be)wohnen, wirtschaften, ausrüsten"
      },
      {
        label: "búd",
        variations: "búðar, búð, búd, búðir, búda, búðum, búdir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Bude, Zeit"
      },
      {
        label: "burt",
        type: "Ad.",
        translation: "fort, weg"
      },
      {
        label: "bygð",
        variations: "bygðar, bygð, bygð, bygðir, bygða, bygðum, bygðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Besiedlung, Gegend, Wohnsitz"
      },
      {
        label: "byrr",
        variations: "byrjar, byr, byr, byrir, byrja, byrum, byri",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "günstiger Segelwind"
      },
      {
        label: "dagr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Tag"
      },
      {
        label: "dalr",
        type: "s",
        sex: "m",
        root: "A-Stamm",
        translation: "Tal"
      },
      {
        label: "dauðr",
        type: "A ",
        translation: "tot"
      },
      {
        label: "deyja",
        variations: "dó, dóum, dáinn",
        type: "V",
        root: "VI. Abl.",
        translation: "sterben"
      },
      {
        label: "dœma",
        variations: "dœmda",
        type: "V",
        root: "sw. I",
        translation: "urteilen, durch Urteil zuerkennen"
      },
      {
        label: "dómr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Gericht, Urteil"
      },
      {
        label: "dóttir",
        translation: "Tochter "
      },
      {
        label: "draga",
        variations: "dró, drógum, dreginn",
        type: "V",
        root: "VI. Abl.",
        translation: "ziehen"
      },
      {
        label: "draumr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Traum"
      },
      {
        label: "drekka",
        variations: "drakk, drukkum, drukkinn",
        type: "V",
        root: "III. Abl.",
        translation: "trinken"
      },
      {
        label: "drengr",
        variations: "drengs, dreng, dreng, drengir, drengja, drengjum, drengi",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Bursche, Mann"
      },
      {
        label: "drepa",
        variations: "drap, drápum, drepinn",
        type: "V",
        root: "V. Abl.",
        translation: "töten"
      },
      {
        label: "dreyma",
        variations: "dreymda, dreymt",
        type: "V",
        root: "sw. I",
        translation: "träumen"
      },
      {
        label: "duga",
        variations: "dugða, hugðr",
        type: "V",
        root: "sw. III",
        translation: "taugen, helfen"
      },
      {
        label: "dvelja",
        variations: "dvalða",
        type: "V",
        root: "sw. I",
        translation: "sich aufhalten, verzögern"
      },
      {
        label: "dyrr",
        variations: "nur Pl. ",
        type: "S",
        sex: "f/n",
        translation: "Tür(öffnung)"
      },
      {
        label: "eða",
        type: "KW",
        translation: "oder"
      },
      {
        label: "ef",
        type: "KW",
        translation: "wenn, falls"
      },
      {
        label: "eiga",
        variations: "á, eigum, átta, áttr",
        type: "V",
        root: "pr.pr.",
        translation: "besitzen"
      },
      {
        label: "eigi",
        variations: "ei, ekki",
        type: "Ad.",
        translation: "nicht, eigi né = weder noch"
      },
      {
        label: "eldr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Feuer"
      },
      {
        label: "en",
        type: "KW",
        translation: "aber/und, als"
      },
      {
        label: "enn",
        type: "Ad.",
        translation: "noch, wieder"
      },
      {
        label: "er",
        type: "KW",
        translation: "Relativpartikel"
      },
      {
        label: "erendi",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Auftrag, Botschaft, Nachricht, Angelegenheit"
      },
      {
        label: "ey",
        variations: "eyjar, ey/eyju, ey/eyju, eyjar, eyja, eyum, eyjar",
        type: "S",
        sex: "f",
        translation: "Insel"
      },
      {
        label: "fá",
        variations: "fekk, fengum, fenginn",
        type: "V",
        root: "red.",
        translation: "geben, bekommen"
      },
      {
        label: "faðir",
        translation: "Vater   "
      },
      {
        label: "fagna",
        variations: "fagnaða",
        type: "V",
        root: "sw. II",
        translation: "freudig begrüssen"
      },
      {
        label: "fagr",
        variations: "fǫgr, fagrt",
        type: "A ",
        translation: "schön, hübsch"
      },
      {
        label: "falla",
        variations: "fell, fellum, fallinn",
        type: "V",
        root: "red.",
        translation: "fallen "
      },
      {
        label: "fang",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Griff, ausgebreitete Arme, Ringkampf, Pl. Mittel, Möglichkeit"
      },
      {
        label: "fár",
        type: "A ",
        translation: "wenig, kaum ein, Pl. Wenige"
      },
      {
        label: "fara",
        variations: "fór, fórum, farinn",
        type: "V",
        root: "VI. Abl.",
        translation: "gehen, sich begeben, fahren"
      },
      {
        label: "fast",
        type: "Ad.",
        translation: "fest, eifrig, sehr"
      },
      {
        label: "fé",
        variations: "fjar, fé, fé",
        type: "S",
        sex: "n",
        root: "u-Stamm",
        translation: "vieh, Geld"
      },
      {
        label: "feðgar",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Vater und Sohn bzw. Vater und Söhne"
      },
      {
        label: "félagi",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Handelspartner, Genosse"
      },
      {
        label: "ferð",
        variations: "ferðar, ferð, ferð, ferðir, ferða, ferðum, ferðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Fahrt, Reise"
      },
      {
        label: "festa",
        variations: "festa, festr",
        type: "V",
        root: "sw. I",
        translation: "festmachen, befestigen"
      },
      {
        label: "finna",
        variations: "fann, fundum, fundinn",
        type: "V",
        root: "III. Abl.",
        translation: "finden"
      },
      {
        label: "fjall",
        variations: "fjalls, fjalli, fjall, fjǫll, fjalla, fjǫllum, fjǫll",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Berg, Gebirge"
      },
      {
        label: "fjǫlmenni",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Menschenmenge"
      },
      {
        label: "fjǫrðr",
        variations: "fjarðar, firði, fjǫrð, fjarða, fjǫrðum, fjǫrðu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Fjord"
      },
      {
        label: "flokkr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Schar"
      },
      {
        label: "flytja",
        variations: "flutta, fluttr",
        type: "V",
        root: "sw. I",
        translation: "bringen, (eine Rede) vortragen"
      },
      {
        label: "fœra",
        variations: "fœrða, fœrðr",
        type: "V",
        root: "sw. I",
        translation: "führen, bringen"
      },
      {
        label: "fǫr ",
        variations: "farar, fǫr, fǫr, farar, fara, fǫrum, farar",
        type: "S",
        sex: "f",
        translation: "Fahrt, Reise"
      },
      {
        label: "fǫrnutaur",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Reisegefaehrte"
      },
      {
        label: "fóstbróðir",
        translation: "Ziehbruder, Blutsbruder "
      },
      {
        label: "fóstri",
        variations: "fóstra, fóstra, fóstra, fóstrar, fóstra, fóstrum, fóstrar",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Pflegevater, Pflegesohn"
      },
      {
        label: "fótr",
        variations: "fótar, fœti, fót, fœtr, fóta, fótum, fœtr",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Fuss"
      },
      {
        label: "frá",
        type: "KW",
        translation: "m. Dat: von, von…weg, Adv: weg, fort"
      },
      {
        label: "frændi",
        variations: "frænda, frænda, frænda, frændr, frænda, frændum, frændr",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Blutsverwandter"
      },
      {
        label: "fram",
        type: "Ad.",
        translation: "vorwärts"
      },
      {
        label: "frétta",
        variations: "frétta, fréttr",
        type: "V",
        root: "sw. I",
        translation: "fragen, forschen, zu erfahren suchen"
      },
      {
        label: "fundr",
        variations: "fundar, fundi, fund, fundir, funda, fundum, fundir",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Treffen, Begegnung"
      },
      {
        label: "fylgja",
        variations: "fylgða, fylgðr",
        type: "V",
        root: "sw. I",
        translation: "folgen"
      },
      {
        label: "fyrir",
        type: "KW",
        translation: "m. Dat. Und Akk.: vor, Adv. Davor, voran"
      },
      {
        label: "fyrr",
        variations: "fyrst",
        type: "Ad.",
        translation: "vorher, früher"
      },
      {
        label: "fyrri",
        type: "A ",
        translation: "(komp.) der frührere, der vordere, Sup. Der erste"
      },
      {
        label: "fýsa",
        variations: "fýsta, fýstr",
        type: "V",
        root: "sw. I",
        translation: "begierig machen"
      },
      {
        label: "gæta",
        variations: "gætta, gættr",
        type: "V",
        root: "sw. I",
        translation: "achtgeben auf, bewachen, sich in Acht nehmen"
      },
      {
        label: "gamall",
        type: "A ",
        translation: "alt"
      },
      {
        label: "ganga",
        variations: "gekk, gengum, genginn",
        type: "V",
        root: "red.",
        translation: "gehen   "
      },
      {
        label: "garðr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Zaun, Hof, Gehöft"
      },
      {
        label: "gefa",
        variations: "gaf, gáfum, getinn",
        type: "V",
        root: "V. Abl.",
        translation: "geben"
      },
      {
        label: "gegnum",
        type: "KW",
        translation: "m. Akk: durch, Adv: hindurch"
      },
      {
        label: "gera",
        variations: "gerða, gǫrr",
        type: "V",
        root: "sw. I",
        translation: "tun, machen"
      },
      {
        label: "gerð",
        variations: "gerðar, gerð, gerð, gerðir, gerða, gerðum, gerðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Tun, Handlung"
      },
      {
        label: "geta",
        variations: "gat, gátum, getinn",
        type: "V",
        root: "V. Abl.",
        translation: "bekommen, zeugen, gebären, erwähnen, raten"
      },
      {
        label: "gipta",
        variations: "gipta, gipt",
        type: "V",
        root: "sw. I",
        translation: "verheiraten (einer Frau)"
      },
      {
        label: "gjalda",
        variations: "galt, guldum, goldinn",
        type: "V",
        root: "III. Abl.",
        translation: "bezahlen"
      },
      {
        label: "gjarna",
        variations: "heldr, helzt",
        type: "Ad.",
        translation: "gerne (lieber, am liebsten)"
      },
      {
        label: "gjǫf",
        variations: "gjafar, gjǫf, gjǫf, gjafar/gjafir, gjafa, gjǫfum, gjafar/gjafir",
        type: "S",
        sex: "f",
        translation: "Gabe, Geschenk"
      },
      {
        label: "goðord",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Godentum"
      },
      {
        label: "góðr",
        type: "A ",
        translation: "gut"
      },
      {
        label: "grið",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Aufenthaltsrecht, Pl. Frieden, Waffenstillstand, Sicherheit"
      },
      {
        label: "gripr",
        variations: "gripar, grip, grip, gripir, gripa, gripum, gripi",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Besitzstück, Kostbarkeit"
      },
      {
        label: "hætta",
        variations: "hætta, hættr",
        type: "V",
        root: "sw. I",
        translation: "aufhören"
      },
      {
        label: "haf",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Meer"
      },
      {
        label: "hafa",
        variations: "hafða, hafðr",
        type: "V",
        root: "sw. III",
        translation: "haben"
      },
      {
        label: "halda",
        variations: "helt, heldum, haldinn",
        type: "V",
        root: "red.",
        translation: "halten"
      },
      {
        label: "hálfr",
        type: "A ",
        translation: "halb, zur Hälfte, hálfr annarr - anderthalb; hálfu meiri - doppelt so groß"
      },
      {
        label: "háls",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Hals, Nacken"
      },
      {
        label: "harðr",
        type: "A ",
        translation: "hart, fest, stark, streng, schroff, schwierig"
      },
      {
        label: "hart",
        type: "Ad.",
        translation: "heftig"
      },
      {
        label: "háttr",
        variations: "háttar, hætti, hátt, hættir, hátta, háttum, háttu",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Art, Weise, Verhalten, Brauch"
      },
      {
        label: "haugr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Huegel, Grabhuegel"
      },
      {
        label: "haust",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Herbst"
      },
      {
        label: "heðan",
        type: "Ad.",
        translation: "von hier"
      },
      {
        label: "hefja",
        variations: "hóf, hófum, hafinn",
        type: "V",
        root: "VI. Abl.",
        translation: "beginnen"
      },
      {
        label: "hefna",
        variations: "hefnda, hefndr",
        type: "V",
        root: "sw. I",
        translation: "rächen (mit Gen.)"
      },
      {
        label: "heiðr",
        variations: "heiðar, heiði, heiði, heiðar, heiða, heiðum, heiðar",
        type: "S",
        sex: "f",
        translation: "Heide, Hochebene"
      },
      {
        label: "heill",
        type: "A ",
        translation: "heil, ganz, unbeschädigt"
      },
      {
        label: "heilsa",
        variations: "heilsaða, heilsaðr",
        type: "V",
        root: "sw. II",
        translation: "Heil wünschen, begrüssen, willkommen heissen"
      },
      {
        label: "heim",
        type: "Ad.",
        translation: "nach Hause"
      },
      {
        label: "heima",
        type: "Ad.",
        translation: "zu Hause"
      },
      {
        label: "heimamaðr",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Hausgenosse"
      },
      {
        label: "heiman",
        type: "Ad.",
        translation: "von zu Hause fort"
      },
      {
        label: "heimta",
        variations: "heimta, heimtr",
        type: "V",
        root: "sw. I",
        translation: "holen, zu sich rufen"
      },
      {
        label: "heita",
        variations: "hét, hétum, heitinn",
        type: "V",
        root: "red.",
        translation: "heissen"
      },
      {
        label: "hellir",
        variations: "hellis, helli, helli, hellar, hella, hellum, hella",
        type: "S",
        sex: "m",
        root: "ja",
        translation: "Felsenhoehle"
      },
      {
        label: "hér",
        type: "Ad.",
        translation: "hier, hierher"
      },
      {
        label: "herað",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Bezirk, Gegend"
      },
      {
        label: "herra",
        variations: "herra, herra, herra, herrar, herrum, herra",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Herr, Gebieter"
      },
      {
        label: "hestr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Pferd"
      },
      {
        label: "hey",
        variations: "heys, heyi, hey, hey, heyja, heijum, hey",
        type: "S",
        sex: "n",
        root: "ja-Stamm kurz",
        translation: "Heu, Pl. Heuvorräte, Futter"
      },
      {
        label: "heyra",
        variations: "heyrða, heyrðr",
        type: "V",
        root: "sw. I",
        translation: "hören"
      },
      {
        label: "hindar",
        variations: "hinzt",
        type: "Ad.",
        translation: "später"
      },
      {
        label: "hingað",
        type: "Ad.",
        translation: "hierher"
      },
      {
        label: "hirða",
        variations: "hirða/hirta, hirtr",
        type: "V",
        root: "sw. I",
        translation: "hüten"
      },
      {
        label: "hitta",
        variations: "hitta, hittr",
        type: "V",
        root: "sw. I",
        translation: "treffen, begegnen, finden, besuchen"
      },
      {
        label: "hjá",
        type: "KW",
        translation: "m. Dat: bei, neben, Adv. Dabei, daneben"
      },
      {
        label: "hjarta",
        variations: "hjarta, hjarta, hjarta, hjǫrtu, hjartna, hjǫrtum, hjǫrtu",
        type: "S",
        sex: "n",
        root: "n-Stamm",
        translation: "Herz"
      },
      {
        label: "hjóðliga",
        type: "Ad.",
        translation: "leise, still, lautlos, heimlich"
      },
      {
        label: "hlaupa",
        variations: "hljóp, hljópum, hlaupinn",
        type: "V",
        root: "red.",
        translation: "springen, laufen"
      },
      {
        label: "hljóta",
        variations: "hlaut, hlutum, hlotinn",
        type: "V",
        root: "II. Abl.",
        translation: "bekommen, erlangen"
      },
      {
        label: "hlutr",
        variations: "hlutar, hlut, hlut, hlutir, hluta, hlutum, hluti",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Anteil, Teil, Ding"
      },
      {
        label: "hlýða",
        variations: "hlýdda, hlýddr",
        type: "V",
        root: "sw. I",
        translation: "lauschen, hören auf, befolgen"
      },
      {
        label: "hǫfðingi",
        variations: "hǫfðingja, hǫfðingja, hǫfðingja, hǫfðdingjar, hǫfðingja, hǫfðingjum, hǫfðingja",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Anführer, Häuptling, Mächtiger"
      },
      {
        label: "hǫfuð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Haupt, Kopf"
      },
      {
        label: "hǫgg",
        variations: "hǫggs, hǫggvi, hǫgg, hǫgg, hǫggva, hǫggum, hǫgg",
        type: "S",
        sex: "n",
        root: "wa-Stamm",
        translation: "Hieb, Schlag"
      },
      {
        label: "hǫggva",
        variations: "hjó, hjoggum, hǫggvinn",
        type: "V",
        root: "red.",
        translation: "hauen, schlagen"
      },
      {
        label: "hólmr",
        type: "s",
        sex: "m",
        root: "A-Stamm",
        translation: "kleine Insel, Holm"
      },
      {
        label: "hǫnd",
        variations: "handar, hendi, hǫnd, hendr, handa, hǫndum, hendr",
        type: "S",
        sex: "f",
        translation: "Hand"
      },
      {
        label: "horfa",
        variations: "horfða, hafðr",
        type: "V",
        root: "sw. III",
        translation: "blicken, sehen"
      },
      {
        label: "hrið",
        variations: "hriðar, hrið, hrið, hriðir, hriða, hridum, hríðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Unwetter, Sturm, Weile, Zeitlang"
      },
      {
        label: "hringr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Ring, Kreis"
      },
      {
        label: "hross",
        variations: "hross, hrossi, hross, hross, hrossa, hrossum, hross",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Ross, Pferd, Stute"
      },
      {
        label: "hugr",
        variations: "hugar, hug, hug, hugir, huga, hugum, hugi",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Sinn, Gefühl, Gedanken"
      },
      {
        label: "hurð",
        variations: "hurðar, hurð/hurðu, hurð, hurðir, hurða, hurðum, hurðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Tür(füllung)"
      },
      {
        label: "hús ",
        variations: "húss, húsi, hús, hús, húsa, húsum, hús",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Haus"
      },
      {
        label: "húsfreyja",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Hausfrau, Hausherrin"
      },
      {
        label: "húskarl",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "(freier) Knecht, Gefolgsmann"
      },
      {
        label: "hvar",
        type: "Ad.",
        translation: "wo"
      },
      {
        label: "hvárt",
        type: "KW",
        translation: "ob   "
      },
      {
        label: "hverfa",
        variations: "hvarf, hurfum, hofrinn",
        type: "V",
        root: "III. Abl.",
        translation: "verschwinden"
      },
      {
        label: "hvergi",
        type: "Ad.",
        translation: "nirgends"
      },
      {
        label: "hversu",
        type: "Ad.",
        translation: "wie, auf welche Weise"
      },
      {
        label: "hvert",
        type: "Ad.",
        translation: "wohin"
      },
      {
        label: "hví",
        type: "KW",
        translation: "warum"
      },
      {
        label: "hyggja",
        variations: "hugða, hug(a)ðr",
        type: "V",
        root: "sw. I",
        translation: "meinen, vermuten, (sich) denken"
      },
      {
        label: "í",
        type: "KW",
        translation: "m. Dat: in (wo?), m. Akk. In (wonin?)"
      },
      {
        label: "í því",
        type: "KW",
        translation: "im selben Moment, Augenblick"
      },
      {
        label: "illa",
        variations: "verri, verst",
        type: "Ad.",
        translation: "schlecht"
      },
      {
        label: "illr",
        type: "A ",
        translation: "schlecht, schlimm, übel"
      },
      {
        label: "inni",
        type: "Ad.",
        translation: "drinnen, darin"
      },
      {
        label: "jafnan",
        type: "Ad.",
        translation: "immer"
      },
      {
        label: "jarl",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Jarl"
      },
      {
        label: "játa",
        variations: "játta/játaða",
        type: "V",
        root: "sw. I",
        translation: "ja sagen, zustimmen"
      },
      {
        label: "jól",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Julfest, Weihnachten"
      },
      {
        label: "jǫrð",
        variations: "jarðar, jǫrð, jǫrð, jarðir, jarða, jǫrðum, jarðir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Erde"
      },
      {
        label: "kalla",
        variations: "kallaða, kallaðr",
        type: "V",
        root: "sw. II",
        translation: "rufen, schreien, nennen"
      },
      {
        label: "karl",
        type: "S ",
        sex: "m",
        root: "A-Stamm",
        translation: "Mann"
      },
      {
        label: "kasta",
        variations: "kastaða, kastaðr",
        type: "V",
        root: "sw. II",
        translation: "werfen"
      },
      {
        label: "kaup ",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Kauf, Handel, Geschäft"
      },
      {
        label: "kaupa",
        variations: "keypta, keyptr",
        type: "V",
        root: "sw. III",
        translation: "kaufen"
      },
      {
        label: "kauptmaðr",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Kaufmann"
      },
      {
        label: "kenna",
        variations: "kenda, kendr",
        type: "V",
        root: "sw. I",
        translation: "kennen, erkennen, spüren, lehren"
      },
      {
        label: "kirkja",
        variations: "kirkju, kirkju, kirkju, kirkjur, kirkna, kirkjum, kirkjur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Kirche"
      },
      {
        label: "kjósa",
        variations: "kaus, kurum, korinn",
        type: "V",
        root: "II. Abl.",
        translation: "wählen, auswählen"
      },
      {
        label: "klæði",
        variations: "klæðis, klæði, klæði, klæða, klæðum, klæði",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Tuch, Stoff, Kleidung"
      },
      {
        label: "koma",
        variations: "kom, kómum, kominn",
        type: "V",
        root: "IV. Abl.",
        translation: "kommen"
      },
      {
        label: "kona",
        variations: "konu, konu, konu, konur, kvenna, kvonum, konur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Frau"
      },
      {
        label: "konugr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "König"
      },
      {
        label: "kostr",
        variations: "kostar, kosti, kost, kostir, kosta, kostum, kosti",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Wahl, Möglichkeit, Pl. Bedingungen"
      },
      {
        label: "kunna",
        variations: "kann, kunnum, kunna, kunnat",
        type: "V",
        root: "pr.pr.",
        translation: "können, kennen, wissen, verstehen"
      },
      {
        label: "kvæði",
        variations: "kvæðis, kvæði, kvæði, kvæði, kvæða, kvæðum, kvæði",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Gedicht"
      },
      {
        label: "kveða",
        variations: "kvað, kvaðum (kóðum), kveðinn",
        type: "V",
        root: "V. Abl.",
        translation: "sagen, vortragen"
      },
      {
        label: "kveðja",
        variations: "kvadda, kvaddr",
        type: "V",
        root: "sw. I",
        translation: "anreden, begrüssen"
      },
      {
        label: "kveld",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Abend"
      },
      {
        label: "kyrr",
        type: "A ",
        translation: "ruhig"
      },
      {
        label: "lag",
        variations: "lags, lagi, lag, lǫg, laga, lǫgum, lǫg",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Lage, Stoss, Pl. Gesetze"
      },
      {
        label: "land",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Land"
      },
      {
        label: "langr",
        type: "A ",
        translation: "lange"
      },
      {
        label: "langt",
        variations: "viða, viðarr, viðast",
        type: "Ad.",
        translation: "weit"
      },
      {
        label: "láta",
        variations: "lét, létum, látinn",
        type: "V",
        root: "red.",
        translation: "lassen"
      },
      {
        label: "launa",
        variations: "launaða, launaðr",
        type: "V",
        root: "sw. II",
        translation: "lohnen, vergelten"
      },
      {
        label: "leggja",
        variations: "lagða, lag(i)ðr",
        type: "V",
        root: "sw. I",
        translation: "legen"
      },
      {
        label: "leið",
        variations: "leiðar, leið, leið, leiðir, leiða, leiðdum, leiðir",
        type: "S",
        sex: "f",
        translation: "Weg, Strecke"
      },
      {
        label: "leiða",
        variations: "leidda, leiddr",
        type: "V",
        root: "sw. I",
        translation: "leiten"
      },
      {
        label: "leika",
        variations: "lék, lékum, leikinn",
        type: "V",
        root: "red.",
        translation: "spielen"
      },
      {
        label: "leikr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Spiel"
      },
      {
        label: "leita",
        variations: "leitaða, leitaðr",
        type: "V",
        root: "sw. II",
        translation: "suchen (mit Gen.)"
      },
      {
        label: "lengi",
        type: "Ad.",
        translation: "lange"
      },
      {
        label: "létta",
        variations: "létta, léttr",
        type: "V",
        root: "sw. I",
        translation: "aufhören"
      },
      {
        label: "leysa",
        variations: "leysta, leystr",
        type: "V",
        root: "sw. I",
        translation: "lösen"
      },
      {
        label: "lið",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Gefolge, Mannschaft, Hilfe"
      },
      {
        label: "líða",
        variations: "leið, liðum, liðinn",
        type: "V",
        root: "I. Abl.",
        translation: "gleiten, dahingehen, verstreichen"
      },
      {
        label: "liðveizla",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Hilfeleistung, Unterstützung"
      },
      {
        label: "líf",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Leben "
      },
      {
        label: "lifa",
        variations: "lifða, lifaðr",
        type: "V",
        root: "sw. III",
        translation: "Leben "
      },
      {
        label: "liggja",
        variations: "lá, lágum, leginn",
        type: "V",
        root: "V. Abl.",
        translation: "liegen"
      },
      {
        label: "lík",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Körper, Leiche"
      },
      {
        label: "líka",
        variations: "líkaða, líkaðr",
        translation: "gefallen"
      },
      {
        label: "líkr",
        variations: "glíkr",
        type: "A ",
        translation: "gleich, ähnlich"
      },
      {
        label: "líta",
        variations: "leit, litum, litinn",
        type: "V",
        root: "I. Abl.",
        translation: "sehen"
      },
      {
        label: "lítill",
        type: "A ",
        translation: "kleine Insel, Holm"
      },
      {
        label: "lítt",
        variations: "minnr, minnst",
        type: "Ad.",
        translation: "wenig"
      },
      {
        label: "ljósta",
        variations: "laust, lustum, lostinn",
        type: "V",
        root: "II. Abl.",
        translation: "schlagen"
      },
      {
        label: "lúka",
        variations: "lauk, lukum, lokinn",
        type: "V",
        root: "II. Abl.",
        translation: "schliessen"
      },
      {
        label: "lýsa",
        variations: "lýsta, lýstr",
        type: "V",
        root: "sw. I",
        translation: "hell werden, leuchten, bekannt machen"
      },
      {
        label: "maðr",
        variations: "manns, manni, mann, menn, manna, mǫnnum, menn",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Mensch, Mann"
      },
      {
        label: "mæla",
        variations: "mælta, mæltr",
        type: "V",
        root: "sw. I",
        translation: "sprechen, sagen"
      },
      {
        label: "mágr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "angeheirateter Verwandter"
      },
      {
        label: "mál",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Rede, Sprache, Gespraech, Erzaehlung, Sache, Angelegenheit"
      },
      {
        label: "margr",
        type: "A ",
        translation: "manch, viel, Pl. Viele"
      },
      {
        label: "matr",
        variations: "matar, mat, mat",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Speise, Essen"
      },
      {
        label: "með",
        type: "KW",
        translation: "m. Dat. Und Akk: mit"
      },
      {
        label: "með því",
        type: "KW",
        translation: "weil, da"
      },
      {
        label: "meðan",
        type: "KW",
        translation: "solange, während"
      },
      {
        label: "meðan",
        type: "Ad.",
        translation: "während"
      },
      {
        label: "mega",
        variations: "má, megum, mátta, mátt",
        type: "V",
        root: "pr.pr.",
        translation: "können, imstande sein, die Möglichkeit haben"
      },
      {
        label: "mein",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Schaden, Leid, Krankheit"
      },
      {
        label: "mikill",
        type: "A ",
        translation: "gross"
      },
      {
        label: "mikit",
        type: "Ad.",
        translation: "viel (vor Komp.)"
      },
      {
        label: "milli",
        type: "KW",
        translation: "m. Gen: zwischen, Adv. Dazwischen"
      },
      {
        label: "missa",
        variations: "missta, misstr",
        type: "V",
        root: "sw. I",
        translation: "vermissen, verlieren (mit Gen.)"
      },
      {
        label: "mjǫk",
        type: "Ad.",
        translation: "sehr, "
      },
      {
        label: "móðir",
        translation: "Mutter"
      },
      {
        label: "morginn",
        variations: "Dat. Morni",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Morgen"
      },
      {
        label: "mǫrk",
        variations: "merkr, mǫrk, mǫrk, merkr, marka, mǫrkum, merkr",
        type: "S",
        sex: "f",
        translation: "Gewichts-, Geldeinheit"
      },
      {
        label: "mót",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Treffen, Zusammenkunft"
      },
      {
        label: "móti",
        variations: "mot",
        type: "KW",
        translation: "m.Dat: gegen,"
      },
      {
        label: "munu",
        variations: "mun, munum, mynda (munda)",
        type: "V",
        root: "pr.pr.",
        translation: "werden"
      },
      {
        label: "ná",
        variations: "náda, nátt",
        type: "V",
        root: "sw. III",
        translation: "erreichen, erlangen, mit Dat. Können"
      },
      {
        label: "nærr",
        variations: "næst",
        type: "Ad.",
        translation: "näher"
      },
      {
        label: "nafn",
        variations: "nafns, nafni, nafn, nafna, nǫfnum, nǫfn",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: name
      },
      {
        label: "naut",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Rind, Vieh"
      },
      {
        label: "neðan",
        type: "Ad.",
        translation: "von unten, nach oben"
      },
      {
        label: "nefna",
        variations: "nefnda, nefndr",
        type: "V",
        root: "sw. I",
        translation: "nennen"
      },
      {
        label: "nema",
        type: "KW",
        translation: "ausser"
      },
      {
        label: "nema",
        variations: "nam, námum, numinn",
        type: "V",
        root: "IV. Abl.",
        translation: "nehmen, lernen"
      },
      {
        label: "nenna",
        variations: "nennta, nenntr",
        type: "V",
        root: "sw. I",
        translation: "Lust haben zu, das Herz haben zu"
      },
      {
        label: "nes",
        variations: "ness, nesi, nes, nes, nesja, nesjum, nes",
        type: "S",
        sex: "n",
        root: "ja-Stamm kurz",
        translation: "Landzunge, Landspitze, Vorgebirge"
      },
      {
        label: "niðr",
        type: "Ad.",
        translation: "hinab"
      },
      {
        label: "njóta",
        variations: "naut, nutum, notinn",
        type: "V",
        root: "II. Abl.",
        translation: "geniessen"
      },
      {
        label: "norðan",
        type: "Ad.",
        translation: "von Norden, nach Süden"
      },
      {
        label: "nótt",
        variations: "náttar/nætr, nótt, nótt, nætr, nátta, nóttum, nætr",
        type: "S",
        sex: "f",
        translation: "Nacht"
      },
      {
        label: "nú",
        type: "Ad.",
        translation: "nun"
      },
      {
        label: "ofan",
        type: "Ad.",
        translation: "herab, herunter"
      },
      {
        label: "ok   ",
        type: "KW",
        translation: "und zwar"
      },
      {
        label: "ok þá",
        type: "KW",
        translation: "und zwar"
      },
      {
        label: "opt",
        variations: "optar, optast",
        type: "Ad.",
        translation: "oft"
      },
      {
        label: "ór",
        type: "KW",
        translation: "m. Dat: aus, aus…heraus, von"
      },
      {
        label: "orð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Wort, Nachricht, Gerede"
      },
      {
        label: "øx",
        variations: "øxar, øxi, øx, øxar, øxa, øxum, øxar",
        type: "S",
        sex: "f",
        translation: "Axt"
      },
      {
        label: "ráð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Rat, Entschluss, Herrschaft, Heirat"
      },
      {
        label: "ráða",
        variations: "réð, réðum, ráðinn",
        type: "V",
        root: "red.",
        translation: "raten, herrschen, bestimmen"
      },
      {
        label: "reka",
        variations: "rak, rákum, rekinn",
        type: "V",
        root: "V. Abl.",
        translation: "treiben"
      },
      {
        label: "rekkja",
        variations: "rekkju, rekkju, rekkju, rekkjur, rekkna, rekkjum, rekkjur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Bett"
      },
      {
        label: "renna",
        variations: "rann, runnum, runninn",
        type: "V",
        root: "III. Abl.",
        translation: "rennen"
      },
      {
        label: "reyna",
        variations: "reynda, reyndr",
        type: "V",
        root: "sw. I",
        translation: "erproben, erfahren"
      },
      {
        label: "ríða",
        variations: "reið, riðum, riðinn",
        type: "V",
        root: "I. Abl.",
        translation: "reiten"
      },
      {
        label: "ríki",
        variations: "Pl. Ríki, ríkja, ríkjum, ríki",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Reich, Herrschaft"
      },
      {
        label: "rísa",
        variations: "reis, risum, risinn",
        type: "V",
        root: "I. Abl.",
        translation: "sich erheben, entstehen"
      },
      {
        label: "róa",
        variations: "rera, rerum, róinn",
        type: "V",
        root: "red.",
        translation: "rudern"
      },
      {
        label: "rœða",
        variations: "rœdda, rœddr",
        type: "V",
        root: "sw. I",
        translation: "reden, sprechen"
      },
      {
        label: "rúm",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Raum, Platz, Schlafplatz, Bettstelle"
      },
      {
        label: "sær",
        variations: "sjór, sjár, sævar, sævi, sæ",
        type: "S",
        sex: "m",
        root: "wa",
        translation: "die See, Meer"
      },
      {
        label: "sætt",
        variations: "sættar, sætt, sætt, sættir, sætta, sættum, sættir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Vertrag, Verlgleich"
      },
      {
        label: "sætta",
        variations: "sætta, sættr",
        type: "V",
        root: "sw. I",
        translation: "einen Vergleich herbeiführen zwichen, aussöhnen"
      },
      {
        label: "safna",
        variations: "safnaða, safnaðr",
        type: "V",
        root: "sw. II",
        translation: "sammeln"
      },
      {
        label: "saga",
        variations: "sǫgu, sǫgu, sǫgu, sǫgur, sagna, sǫgum, sǫgur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Saga, Erzählung"
      },
      {
        label: "saman",
        type: "Ad.",
        translation: "zusammen, gemeinsam"
      },
      {
        label: "sannr",
        type: "A ",
        translation: "wahr, richtig, rechtmässig"
      },
      {
        label: "sár",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Wunde"
      },
      {
        label: "sárr",
        type: "A ",
        translation: "verwundet, wund"
      },
      {
        label: "sax",
        variations: "sax, saxi, sax, sǫx, saxa, sǫxum, sǫx",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Kurzschwert, Pl. Schere"
      },
      {
        label: "segja",
        variations: "sagða, sagðr",
        type: "V",
        root: "sw. III",
        translation: "sagen   "
      },
      {
        label: "seint",
        type: "Ad.",
        translation: "spät"
      },
      {
        label: "sekr",
        type: "A ",
        translation: "straffällig, schuldig, schuldig zu zahlen, geächtet, vogelfrei"
      },
      {
        label: "sekt",
        variations: "sektar, sekt, sekt, sektir, sekta, sektum, sektir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Schuld, Busse, Strafe, Ächtung"
      },
      {
        label: "sel",
        variations: "sels, seli, sel, sel, selja, seljum, sel",
        type: "S",
        sex: "n",
        root: "ja-Stamm kurz",
        translation: "Sennhütte"
      },
      {
        label: "selja",
        variations: "selda, seldr",
        type: "V",
        root: "sw. I",
        translation: "verkaufen"
      },
      {
        label: "sem",
        type: "KW",
        translation: "wie"
      },
      {
        label: "senda",
        variations: "senda, sendr",
        type: "V",
        root: "sw. I",
        translation: "senden"
      },
      {
        label: "setja",
        variations: "setta, settr",
        type: "V",
        root: "sw. I",
        translation: "setzen"
      },
      {
        label: "síð",
        variations: "(síðarr, síðast)",
        type: "Ad.",
        translation: "spät"
      },
      {
        label: "síðan",
        type: "Ad.",
        translation: "dann, seitdem"
      },
      {
        label: "siðr",
        variations: "siðar, siði, sið, siðir, siða, siðum, siðu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Sitte, Brauch, Lebensweise, Religion"
      },
      {
        label: "síðr",
        type: "Ad.",
        translation: "weniger"
      },
      {
        label: "sigla",
        variations: "siglda, sigldr",
        type: "V",
        root: "sw. I",
        translation: "segeln"
      },
      {
        label: "silfr",
        variations: "silfrs, silfri, silfr",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Silber"
      },
      {
        label: "sinn",
        variations: "eitt sinn, einu sinn = einmal, annat sinn = noch einmal",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Mal"
      },
      {
        label: "sitja",
        variations: "sat, sátum, setinn",
        type: "V",
        root: "V. Abl.",
        translation: "sitzen"
      },
      {
        label: "sjá",
        variations: "sá, sám, sénn",
        type: "V",
        root: "V. Abl.",
        translation: "sehen"
      },
      {
        label: "sjaldan",
        variations: "sjaldnar, sjaldnast",
        type: "Ad.",
        translation: "selten"
      },
      {
        label: "skáli",
        variations: "skála, skála, skála, skálar, skála, skálum, skála",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Haus, Hauptgebäude, Halle"
      },
      {
        label: "skap",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Beschaffenheit, Art, Wesen, -skap = Landschaft"
      },
      {
        label: "skilja",
        variations: "skilda, skildr",
        type: "V",
        root: "sw. I",
        translation: "trennen, unterscheiden, verstehen"
      },
      {
        label: "skip",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Schiffsfuehrer, Kapitaen"
      },
      {
        label: "skipa",
        variations: "skipaða, skipaðr",
        type: "V",
        root: "sw. II",
        translation: "ordnen, regeln, aufstellen"
      },
      {
        label: "skipta",
        variations: "skipta, skiptr",
        type: "V",
        root: "sw. I",
        translation: "teilen, verteilen, von Bedeutung sein, ändern"
      },
      {
        label: "skjǫldr",
        variations: "skjaldar, skildi, skjǫld, skildir, skjalda, skjǫldum, skjǫldu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Schild"
      },
      {
        label: "skjóta",
        variations: "skaut, skutum, skotinn",
        type: "V",
        root: "II. Abl.",
        translation: "schiessen, stossen, schleudern"
      },
      {
        label: "skógr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Wald"
      },
      {
        label: "skorta",
        variations: "skorta, skortr",
        type: "V",
        root: "sw. I",
        translation: "mangeln"
      },
      {
        label: "skótt",
        variations: "brátt",
        type: "Ad.",
        translation: "schnell   "
      },
      {
        label: "skulu",
        variations: "skal, skulum, skylda",
        type: "V",
        root: "pr.pr.",
        translation: "sollen"
      },
      {
        label: "slá",
        variations: "sló, slógum, sleginn",
        type: "V",
        root: "VI. Abl.",
        translation: "schlagen"
      },
      {
        label: "snemma",
        type: "Ad.",
        translation: "bald, früh"
      },
      {
        label: "snúa",
        variations: "snera, snerum, snúinn",
        type: "V",
        root: "red.",
        translation: "wenden, umkehren"
      },
      {
        label: "sœkja",
        variations: "sótta, sóttr",
        type: "V",
        root: "sw. I",
        translation: "suchen, sich begeben, mit at: angreifen"
      },
      {
        label: "sœmd",
        variations: "sœmdar, sœmd, sœmd, sœmdir, sœmda, sœmdum, sœmdir",
        type: "S",
        sex: "f",
        translation: "Ehre, Ansehen"
      },
      {
        label: "sǫk",
        variations: "sakar, sǫk, sǫk, sakar/ir, saka, sǫkum, sakar/ir",
        type: "S",
        sex: "f",
        translation: "Rechtssache, Ursache, Schuld"
      },
      {
        label: "son(r)",
        variations: "sonar, syni, son, synir, sona, sonum, syni",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Sohn"
      },
      {
        label: "sótt",
        variations: "sóttar, sótt, sótt, sótt, sóttir, sótta, sóttum, sóttir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Krankheit, Geburtswesen"
      },
      {
        label: "spjót",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Speer, Spiess"
      },
      {
        label: "spretta",
        variations: "spratt, spruttum, sprottin",
        type: "V",
        root: "III. Abl.",
        translation: "springen"
      },
      {
        label: "spyrja",
        variations: "spurða, spurðr",
        type: "V",
        root: "sw. I",
        translation: "fragen, erfahren"
      },
      {
        label: "staðr",
        variations: "staðar, stað, stað, staðir, staða, stǫdum, staði",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Stätte, Ort, Stelle"
      },
      {
        label: "standa",
        variations: "stóð, stóðum, staðinn",
        type: "V",
        root: "VI. Abl.",
        translation: "stehen"
      },
      {
        label: "stefna",
        variations: "stefnda, stefndr",
        type: "V",
        root: "sw. I",
        translation: "in eine bestimmte Richtung steuern, vorladen"
      },
      {
        label: "steinn",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Stein, Felsen, Edelstein"
      },
      {
        label: "sterkr",
        variations: "styrkr",
        type: "A ",
        translation: "stark, kräftig, fest, haltbar"
      },
      {
        label: "stíga",
        variations: "steig/sté, stigum, stiginn",
        type: "V",
        root: "I. Abl.",
        translation: "steigen, schreiten, gehen, treten"
      },
      {
        label: "stofa",
        variations: "stofu, stofu, stofu, stofur, stofna, stofnum, stofur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Stube, kleine Halle"
      },
      {
        label: "stórr",
        type: "A ",
        translation: "gross"
      },
      {
        label: "stund",
        variations: "stundar, stundu, stund, stundir, stunda, stundum, stundir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Zeit, Weile, Zeitpunkt, Stunde"
      },
      {
        label: "stýrmaðr",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Schiffsfuehrer, Kapitaen"
      },
      {
        label: "suðr",
        type: "Ad.",
        translation: "nach Süden, im Süden"
      },
      {
        label: "sumar",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Sommer"
      },
      {
        label: "sundr",
        type: "Ad.",
        translation: "entzwei, auseinander"
      },
      {
        label: "sunnan",
        type: "Ad.",
        translation: "von Süden, nach Norden"
      },
      {
        label: "svá   ",
        type: "Ad.",
        translation: "so"
      },
      {
        label: "svá at",
        type: "KW",
        translation: "sodass"
      },
      {
        label: "svara",
        variations: "svaraða, svaraðr",
        type: "V",
        root: "sw. II",
        translation: "antworten"
      },
      {
        label: "svefn",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Schlaf"
      },
      {
        label: "sveinn",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Junge, Junger Mann, Diener "
      },
      {
        label: "sveit",
        variations: "sveitar, sveit, sveit, sveitir, sveita, sveitum, sveitir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Schar"
      },
      {
        label: "sverð",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Schwert"
      },
      {
        label: "sýna",
        variations: "sýnda, sýndr",
        type: "V",
        root: "sw. I",
        translation: "zeigen; sýntask = scheinen"
      },
      {
        label: "systir",
        translation: "Schwester"
      },
      {
        label: "taka",
        variations: "tók, tókum, tekinn",
        type: "V",
        root: "VI. Abl.",
        translation: "nehmen, lernen"
      },
      {
        label: "tal",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Zahl, Verzeichnis, Gespraech, Sprache"
      },
      {
        label: "tala",
        variations: "talaða, talaðr",
        type: "V",
        root: "sw. II",
        translation: "sprechen, sagen"
      },
      {
        label: "telja",
        variations: "talða, tal(i)ðr, tǫlð, talt",
        type: "V",
        root: "sw. I",
        translation: "zählen, erzählen, sagen, erklären"
      },
      {
        label: "þá",
        type: "Ad.",
        translation: "da, dann"
      },
      {
        label: "þaðan",
        type: "Ad.",
        translation: "von dort"
      },
      {
        label: "þakka",
        variations: "þakkaða, þakkaðr",
        type: "V",
        root: "sw. II",
        translation: "danken"
      },
      {
        label: "þangað",
        type: "Ad.",
        translation: "dorthin"
      },
      {
        label: "þar",
        type: "Ad.",
        translation: "da, dort"
      },
      {
        label: "þegar",
        type: "Ad.",
        translation: "sofort"
      },
      {
        label: "þiggja",
        variations: "þá, þágum, þeginn",
        type: "V",
        root: "V. Abl.",
        translation: "bekommen"
      },
      {
        label: "þing",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Versammlung, Thing"
      },
      {
        label: "þó at",
        variations: "þótt",
        type: "KW",
        translation: "obwohl, obgleich, wenn auch"
      },
      {
        label: "þora",
        variations: "þorða, þoraðr",
        type: "V",
        root: "sw. III",
        translation: "wagen"
      },
      {
        label: "þræll",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Sklave, (unfreier) Knecht"
      },
      {
        label: "þrifa",
        variations: "þreif, þrifum, þrifinn",
        type: "V",
        root: "I. Abl.",
        translation: "ergreifen"
      },
      {
        label: "þurfa",
        variations: "þarf, þurfum, þurfta, þurft",
        type: "V",
        root: "pr.pr.",
        translation: "nötig haben, brauchen, müssen"
      },
      {
        label: "því at",
        type: "KW",
        translation: "weil, denn, pvi at = deshalb"
      },
      {
        label: "þvi næst",
        type: "KW",
        translation: "als nächstes, demnächst, gleich darauf"
      },
      {
        label: "þykkja",
        variations: "þótta, þóttr",
        type: "V",
        root: "sw. I",
        translation: "dünken, scheinen, med.pass. Glauben, meinen"
      },
      {
        label: "tídeni",
        variations: "nur im Pl.",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Neuigkeiten, Ereignisse"
      },
      {
        label: "tigr/tugr",
        variations: "tigar, tigi, tig, tigir, tiga, tigum, tigu/tigi",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Anzahl von 10"
      },
      {
        label: "til",
        type: "KW",
        translation: "m. Gen: nach, zu (örtl.), bis zu (zeitl.)"
      },
      {
        label: "tími",
        variations: "tíma, tíma, tíma, tímar, tíma, tímum, tíma",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Zeit, Weile, Zeitpunkt, Stunde"
      },
      {
        label: "traust",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Vertrauen, Schutz, Sicherheit"
      },
      {
        label: "trúa",
        variations: "strúða, trúðr",
        type: "V",
        root: "sw. III",
        translation: "glauben, vertrauen"
      },
      {
        label: "tún",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "eingehegter Grasplatz, Hauswiese"
      },
      {
        label: "um",
        type: "KW",
        translation: "m. Akk. Über...hin, um…herum"
      },
      {
        label: "una",
        variations: "unda, unat",
        type: "V",
        root: "sw. III",
        translation: "zufrieden sein (mit)"
      },
      {
        label: "ungr",
        type: "A ",
        translation: "jung   "
      },
      {
        label: "unna",
        variations: "ann, unnum, unna, un(na)t",
        type: "V",
        root: "pr.pr.",
        translation: "lieben"
      },
      {
        label: "upp",
        type: "Ad.",
        translation: "hinauf"
      },
      {
        label: "uppi",
        type: "Ad.",
        translation: "oben"
      },
      {
        label: "úti",
        type: "Ad.",
        translation: "draussen"
      },
      {
        label: "vænn",
        type: "A ",
        translation: "aussichtsreich, erfolgversprechend, hoffnungsvoll, schön, hübsch"
      },
      {
        label: "vænta",
        variations: "vænta, væntr",
        type: "V",
        root: "sw. I",
        translation: "erwarten, hoffen"
      },
      {
        label: "vakna",
        variations: "vaknaða, vaknaðr",
        type: "V",
        root: "sw. II",
        translation: "erwachen"
      },
      {
        label: "valda",
        variations: "olla, valdit",
        type: "V",
        root: "unreg. ",
        translation: "handhaben, verursachen, bewirken"
      },
      {
        label: "ván",
        variations: "vánar, vánu, ván, vánir, vána, vánum, vánir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Erwartung, Aussicht, Hoffnung"
      },
      {
        label: "vandi",
        variations: "vanda, vanda, vanda",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Schwierigkeit"
      },
      {
        label: "vandr",
        variations: "vǫnd, vant",
        type: "A ",
        translation: "schwierig, schwer, genaunehmend"
      },
      {
        label: "vandræði",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Schwierigkeit"
      },
      {
        label: "vanr",
        variations: "vǫn, vant",
        type: "A ",
        translation: "gewöhnt an"
      },
      {
        label: "vápn",
        variations: "vápns, vápni, vápn, vápn, vápna, vápnum, vápn",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Waffe"
      },
      {
        label: "vár",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Fruehling"
      },
      {
        label: "vara",
        variations: "varaða, varaðr",
        type: "V",
        root: "sw. II",
        translation: "warnen, vara sik/varask = sich vorsehen"
      },
      {
        label: "varningr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Ware"
      },
      {
        label: "varr",
        type: "A ",
        translation: "gewahr, in Kenntnis gesetzt, unterrichtet"
      },
      {
        label: "vatn",
        variations: "Pl. Vǫtn",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Wasser, See"
      },
      {
        label: "váttr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Zeuge"
      },
      {
        label: "vaxa",
        variations: "óx, óxum, vaxinn",
        type: "V",
        root: "VI. Abl.",
        translation: "wachsen"
      },
      {
        label: "veðr",
        variations: "veðrs, veðri, veðr",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Wetter"
      },
      {
        label: "vega",
        variations: "vá, vágum, veginn",
        type: "V",
        root: "V. Abl.",
        translation: "kämpfen, töten"
      },
      {
        label: "vegr",
        type: "S",
        sex: "m",
        root: "a./u.",
        translation: "Weg, Richtung, Art"
      },
      {
        label: "veita",
        variations: "veitta, veittr",
        type: "V",
        root: "sw. I",
        translation: "gewähren, geben, erlauben, durchführen"
      },
      {
        label: "veizla",
        variations: "veizlu, veizlu, veizlu, veizlur, veizla, veizlum, veizlur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Fest, Bewirtung"
      },
      {
        label: "vekja",
        variations: "vakþa, vak(i)ðr",
        type: "V",
        root: "sw. I",
        translation: "wecken"
      },
      {
        label: "vera",
        variations: "var, várum, verit",
        type: "V",
        root: "V. Abl.",
        translation: "sein"
      },
      {
        label: "verða",
        variations: "varð, urðum, ordinn",
        type: "V",
        root: "III. Abl.",
        translation: "werden, entstehen, mit Inf. Müssen"
      },
      {
        label: "verðr",
        type: "A ",
        translation: "wert(voll), würdig, verdient"
      },
      {
        label: "verja",
        variations: "varða, varðr",
        type: "V",
        root: "sw. I",
        translation: "wehren, verteidigen"
      },
      {
        label: "verk",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Werk, Arbeit, Tat"
      },
      {
        label: "vestan",
        type: "Ad.",
        translation: "von Westen, nach Osten"
      },
      {
        label: "vestr",
        type: "Ad.",
        translation: "nach Westen, im Westen"
      },
      {
        label: "vetr",
        variations: "vetrar, vetri, vetr, vetr, vetra, vetrum, vetr",
        type: "S",
        sex: "m",
        root: "a./kons.",
        translation: "Winter, Jahr"
      },
      {
        label: "við   ",
        type: "KW",
        translation: "m. Dat: bei, an gegen, mit, m. Akk: gegen"
      },
      {
        label: "viðr",
        variations: "viðar, viði, við, viðir, viða, viðum, viðu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Wald, Baum, Holz"
      },
      {
        label: "víg",
        type: "S",
        sex: "n",
        root: "A-Stamm",
        translation: "Kampf"
      },
      {
        label: "vika",
        variations: "viku, viku, viku, vikur, vikna, vikum, vikur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Woche"
      },
      {
        label: "víkingr",
        type: "S",
        sex: "m",
        root: "A-Stamm",
        translation: "Wikinger, Seeraeuber"
      },
      {
        label: "vili",
        variations: "vilja, vilja, vilja",
        type: "S",
        sex: "m",
        root: "n-Stamm",
        translation: "Wille"
      },
      {
        label: "vilja",
        variations: "vilda, viljaðr",
        type: "V",
        root: "sw. I",
        translation: "wollen"
      },
      {
        label: "vinátta",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Freundschaft"
      },
      {
        label: "vinna",
        variations: "vann, unnum, unninn",
        type: "V",
        root: "III. Abl.",
        translation: "ausführen, arbeiten"
      },
      {
        label: "vinr",
        variations: "vinar, vin, vin, vinir, vina, vinum, vini",
        type: "S",
        sex: "m",
        root: "i-Stamm",
        translation: "Freund"
      },
      {
        label: "vinsæll",
        type: "A ",
        translation: "viele Freunde habend, beliebt"
      },
      {
        label: "virða",
        variations: "virta, virtr",
        type: "V",
        root: "sw. I",
        translation: "schätzen"
      },
      {
        label: "virðing",
        variations: "virðingar, virðingu, virðing, virðingar, virðinga, virðingum, virðingar",
        type: "S",
        sex: "f",
        translation: "Ehre, Ansehen"
      },
      {
        label: "virki",
        type: "S",
        sex: "n",
        root: "ja-Stamm lang",
        translation: "Befestigungsanlage, Gebäude"
      },
      {
        label: "vísa",
        variations: "vísu, vísu, vísu, vísur, vísa, vísum, vísur",
        type: "S",
        sex: "f",
        root: "on-Stamm",
        translation: "Strophe"
      },
      {
        label: "vist",
        variations: "vistar, vist, vist, vistir, vista, vistum, vistir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Aufenthaltsort, Pl. Verpflegung"
      },
      {
        label: "víst",
        type: "Ad.",
        translation: "gewiss"
      },
      {
        label: "vita",
        variations: "veit, vitum, vissa, vitaðr",
        type: "V",
        root: "pr.pr.",
        translation: "wissen"
      },
      {
        label: "vitr",
        type: "A ",
        translation: "klug, verständig, gescheit"
      },
      {
        label: "vǫllr",
        variations: "vallar, velli, vǫll, vellir, valla, vǫllum, vǫllu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Feld, Platz, Ebene, Kampfplatz"
      },
      {
        label: "vǫrn",
        variations: "varnar, vǫrn, vǫrn, varnir, varna, vǫrnum, varnir",
        type: "S",
        sex: "f",
        root: "i-Stamm",
        translation: "Verteidigung"
      },
      {
        label: "vǫxtr",
        variations: "vaxtar, vexti, vǫxt, vextir, vaxta, vǫxtum, vǫxtu",
        type: "S",
        sex: "m",
        root: "u-Stamm",
        translation: "Wuchs, Statur, Grösse"
      },
      {
        label: "yfir",
        type: "KW",
        translation: "m Dat. Über, m. Akk: über, über…hin"
      },
      {
        label: "yrkja",
        variations: "orta, ortr",
        type: "V",
        root: "sw. I",
        translation: "bearbeiten, dichten"
      }
    ];
  private filter: string = '';
  private fields = [
    {key: 'label', label: 'Wort', sortable: true, sortDirection: 'z-a'},
    {key: 'variations', label: 'Variationen', sortable: true, class: 'text-center'},
    {key: 'translation', label: 'Übersetzung', sortable: true, class: 'text-center'},
    {key: 'type', label: 'Typ', sortable: true, class: 'text-center'},
    {key: 'root', label: 'Stamm', sortable: true, class: 'text-center'},
    {key: 'sex', label: 'Sex', sortable: true, class: 'text-center'},
    /*{key: 'isActive', label: 'is Active', formatter: (value, key, item) => { return value ? 'Ja' : 'Nein' }, sortable: true, sortByFormatted: true, filterByFormatted: true },
    {key: 'actions', label: 'Actions'}*/
  ];
  private totalRows: number = 1;
  private currentPage: number = 1;
  private perPage: number = 20;
  private pageOptions: number[] = [20, 50, 100];
  private sortBy: string =  '';
  private sortDesc: boolean = false;
  private sortDirection: string = 'asc';
  private filterOn: [] = [];
  private infoModal = {
    id: 'info-modal',
    title: '',
    content: ''
  };

  get filteredList() {
    console.log('getFilteredList', this.filter);
    let filteredList: IWord[] | null = this.wordList;
    if (this.filter != '') {
      let filter: string = this.filter ? this.filter.toString().toLocaleLowerCase().trim() : '';
      filteredList = this.wordList.filter(function (word) {
        console.log(word.name.indexOf(filter), filter);
        return !word.name.toLocaleLowerCase().trim().indexOf(''+filter+'') ||
                !word.translation.toLocaleLowerCase().trim().indexOf(''+filter+'');
      });
      //filteredList.concat(filteredList, this.wordList.filter(word => word.variations.indexOf(filter)));
      //filteredList.concat(filteredList, this.wordList.filter(word => word.type.indexOf(filter)));
      //filteredList.concat(filteredList, this.wordList.filter(word => word.sex.indexOf(filter)));
      //filteredList.concat(filteredList, this.wordList.filter(word => word.root.indexOf(filter)));
      //filteredList.concat(filteredList, this.wordList.filter(word => word.translation.indexOf(filter)));
    }
    //console.log(filteredList);
    return filteredList;
  }

  get sortOptions() {
    // Create an options list from our fields
    return this.fields
            .filter(f => f.sortable)
            .map(f => {
              return { text: f.label, value: f.key }
            })
  }

  public info(word: IWord, index, button) {
    this.infoModal.title = `Zeilen index: ${index}`;
    this.infoModal.content = JSON.stringify(word, null, 2);
    this.$root.$emit('bv::show::modal', this.infoModal.id, button)
  }

  public resetInfoModal() {
    this.infoModal.title = '';
    this.infoModal.content = '';
  }

  public onFiltered(filteredItems: IWord[]) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  public mounted() {
    this.$nextTick(() => this.$refs.filterInput.focus());
    this.totalRows = this.wordList.length;
  }
}
